import { render, staticRenderFns } from "./top-adv.vue?vue&type=template&id=4b5a74a1&scoped=true"
import script from "./top-adv.vue?vue&type=script&lang=js"
export * from "./top-adv.vue?vue&type=script&lang=js"
import style0 from "./top-adv.vue?vue&type=style&index=0&id=4b5a74a1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5a74a1",
  null
  
)

export default component.exports